import { jsx as _jsx } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../useVerticalTimelineProcessController";
import { TimelineDotDefault, TimelineDotError, TimelineDotSuccess, } from "./TimelineDots";
export function StatusTimelineDotProcess(_a) {
    var _b;
    var data = _a.data, step = _a.step;
    var _c = useVerticalExternalTimelineProcessController({
        data: data,
    }), mustDisplayMessageGotoDetran = _c.mustDisplayMessageGotoDetran, isAttrDateNull = _c.isAttrDateNull, isDateBeforeSecondDate = _c.isDateBeforeSecondDate, findAttributeDateValue = _c.findAttributeDateValue;
    var isProcessDateStep = step.key === "dataProcesso";
    var hasCurrentProcessDate = isDateBeforeSecondDate(data.dataProcesso, (_b = findAttributeDateValue(step.key)) !== null && _b !== void 0 ? _b : undefined);
    if (mustDisplayMessageGotoDetran(step.key)) {
        return _jsx(TimelineDotError, {});
    }
    if (!isProcessDateStep && !hasCurrentProcessDate) {
        return _jsx(TimelineDotDefault, {});
    }
    if (isAttrDateNull(step.key))
        return _jsx(TimelineDotDefault, {});
    return _jsx(TimelineDotSuccess, {});
}
